<ng-container *ngIf="isStaff; else studentView">
	<ng-container *ngTemplateOutlet="teacherView"></ng-container>
</ng-container>

<!--******************************** Teacher View ********************************-->
<ng-template #teacherView>
	<div class="main-page-right teacher-view" [@TeacherOpenOrCloseRequests]="screenService.windowWidth > 795 ? 'Opened' : 'Closed'">
		<app-display-card
			class="app-display-card"
			[title]="'Pass Requests'"
			[hasDivider]="false"
			[fontSize]="'20px'"
			[icon]="'./assets/Notifications (Navy).svg'"
			[inbox]="true"
			[sortIcon]="activeTabIndex === 0 ? sortIconData : null"
			(sortIconClick)="toggleSortPreference()"
			[isStaff]="isStaff">
			<div style="margin-left: 32px">
				<app-notification-turn-on-btn></app-notification-turn-on-btn>
			</div>
			<div [ngClass]="{ 'needs-scroll': needsScroll }" id="mat-tab-wrapper">
				<mat-tab-group
					class="mat-tab-group"
					id="tab-group"
					#tabGroup
					[selectedIndex]="activeTabIndex"
					(selectedIndexChange)="updateActiveTab($event)"
					[animationDuration]="nowRequests?.length || scheduledRequests?.length ? '300ms' : '0ms'"
					disableRipple
					disablePagination>
					<mat-tab>
						<ng-template mat-tab-label>
							<div class="tab-label">
								Now <span class="tab-number" *ngIf="nowRequests?.length">{{ nowRequests.length }}</span>
							</div>
						</ng-template>
						<ng-container *ngIf="passesLoaded">
							<ng-container *ngIf="nowRequests?.length; else noRequestsTeacher">
								<div class="sp-pass-encapsulation" #spNowPassWrapper>
									<sp-pass-collection-v2>
										<sp-collection-title *ngIf="_showRequestTitles">Received</sp-collection-title>
										<sp-pass-tile-medium-v2
											collection-content
											*ngFor="let inv of nowRequests"
											[isStaff]="isStaff"
											[isStudent]="isStudent"
											[studentName]="isStaff ? inv.student.display_name : null"
											[pass]="inv"
											[roomName]="inv.destination.title"
											[roomIcon]="inv.icon"
											[startTime]="inv | requestdate"
											[status]="inv.status"
											[created]="inv.created"
											[colorProfile]="inv.color_profile"
											[sent]="false"
											[received]="true"
											[studentProfilePicture]="inv.student.profile_picture"
											(openPass)="openPassDialog.emit({ pass: inv, fromClick: true, fromEndButton: false })">
										</sp-pass-tile-medium-v2>
									</sp-pass-collection-v2>
								</div>
							</ng-container>
						</ng-container>
					</mat-tab>
					<mat-tab>
						<ng-template mat-tab-label>
							<div class="tab-label">
								Scheduled <span class="tab-number" *ngIf="scheduledRequests?.length">{{ scheduledRequests.length }}</span>
							</div>
						</ng-template>
						<ng-container *ngIf="passesLoaded">
							<ng-container *ngIf="scheduledRequests?.length; else noRequestsTeacher">
								<div class="sp-pass-encapsulation" #spScheduledPassWrapper>
									<sp-pass-collection-v2>
										<sp-collection-title *ngIf="_showRequestTitles">Scheduled</sp-collection-title>
										<sp-pass-tile-medium-v2
											collection-content
											*ngFor="let inv of scheduledRequests"
											[isStaff]="isStaff"
											[isStudent]="isStudent"
											[studentName]="isStaff ? inv.student.display_name : null"
											[pass]="inv"
											[roomName]="inv.destination.title"
											[roomIcon]="inv.icon"
											[startTime]="inv | requestdate"
											[status]="inv.status"
											[created]="inv.created"
											[colorProfile]="inv.color_profile"
											[sent]="false"
											[received]="true"
											[studentProfilePicture]="inv.student.profile_picture"
											(openPass)="openPassDialog.emit({ pass: inv, fromClick: true, fromEndButton: false })">
										</sp-pass-tile-medium-v2>
									</sp-pass-collection-v2>
								</div>
							</ng-container>
						</ng-container>
					</mat-tab>
				</mat-tab-group>
			</div>
		</app-display-card>
	</div>
</ng-template>

<!--******************************** Student View ********************************-->
<ng-template #studentView>
	<div
		class="main-page-right student-view"
		[ngStyle]="{ display: screenService.windowWidth < 800 ? 'none' : 'block' }"
		[@StudentOpenOrCloseRequests]="(showInboxAnimated() | async) ? 'Opened' : 'Closed'">
		<app-display-card
			[title]="'Pass Requests'"
			[hasDivider]="false"
			[fontSize]="'20px'"
			[icon]="'./assets/Notifications (Navy).svg'"
			[inbox]="true"
			[isStaff]="isStaff">
			<app-notification-turn-on-btn></app-notification-turn-on-btn>
			<ng-container *ngIf="receivedRequests2?.length; else noRequestsStudent">
				<sp-pass-collection-v2>
					<sp-collection-title *ngIf="_showRequestTitles">Received</sp-collection-title>
					<sp-pass-tile-medium
						collection-content
						*ngFor="let inv of receivedRequests2"
						[isStaff]="isStaff"
						[isStudent]="isStudent"
						[studentName]="isStaff ? inv.student.display_name : null"
						[roomName]="inv.destination.title"
						[roomIcon]="inv.icon"
						[startTime]="inv | requestdate"
						[status]="inv.status"
						[created]="inv.created"
						[colorProfile]="inv.color_profile"
						[sent]="false"
						[received]="true"
						[studentProfilePicture]="inv.student.profile_picture"
						(click)="openPassDialog.emit({ pass: inv, fromClick: true, fromEndButton: false })"></sp-pass-tile-medium>
				</sp-pass-collection-v2>
			</ng-container>
		</app-display-card>
	</div>
</ng-template>

<!--******************************** No Requests ********************************-->
<ng-template #noRequestsTeacher>
	<div class="no-requests">
		<img class="emoji" [src]="emptyPassRequestMessage.image" alt="Emoji" />
		<span class="message-text">{{ emptyPassRequestMessage.text }}</span>
	</div>
</ng-template>

<ng-template #noRequestsStudent>
	<div class="no-requests"><img src="assets/all-caught-up.svg" alt="checkmark" /> You’re all caught up!</div>
</ng-template>
